module.exports = __webpack_public_path__ + "img/17-climate-conscious-urbanisation.38ac6a84.jpg";